// src/components/Gallery.js
import React from "react";
import "../styles/gallery.css";
import g1 from "../assets/Gallery1.jpg";
import g2 from "../assets/Gallery2.jpeg";
import g3 from "../assets/Gallery3.jpeg";
import g4 from "../assets/Gallery4.jpeg";
import g5 from "../assets/Gallery5.jpeg";
import g6 from "../assets/Gallery6.jpeg";

const IMAGES = [g1, g2, g3, g4, g5, g6];

const Gallery = () => {
  return (
    <div className="container gallery">
      <header className="gallery-header fade-in">
        <p className="section-title">Galerija</p>
        <h2 className="section-heading">Naši najprodavaniji proizvodi</h2>
        <p className="section-subtitle">
          Pogledajte dio atmosfere iz KBIA radionice. U našoj{" "}
          <a
            href="https://shop.kbia.hr/wp/"
            target="_blank"
            rel="noopener noreferrer"
            className="gallery-link"
          >
            TRGOVINI
          </a>{" "}
          možete vidjeti ostalu ponudu proizvoda.
        </p>
      </header>

      <div className="gallery-grid">
        {IMAGES.map((src, idx) => (
          <div className="gallery-item fade-in" key={idx}>
            <img src={src} alt={`KBIA poklon kutija ${idx + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
